import React, { useCallback } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSessionContext } from 'modules/session';
import { AppMenuItemProps } from '../AppMenuItemProps';
import { ReactComponent as LogoutIcon } from '../icons/logout.svg';

interface LogoutMenuItemProps extends AppMenuItemProps {
  onMenuClose: () => void;
}

export const LogoutMenuItem = ({
  classes,
  onMenuClose
}: LogoutMenuItemProps): JSX.Element => {
  const { logout } = useSessionContext();
  const handleLogout = useCallback(() => {
    logout();
    onMenuClose();
  }, [logout, onMenuClose]);

  return (
    <MenuItem
      onClick={handleLogout}
      data-testid="logout-menu"
      className={classes.menuItem}
    >
      <ListItemIcon className={classes.icon}>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage id="appMenu.logout" />
      </ListItemText>
    </MenuItem>
  );
};
